/** @prettier */
import React, { useMemo } from "react";
import { Chart } from "../../util/ChartJsChart";
import {
    buildChartConfig,
    calcPercentage,
    ScoreBreakdownItem,
} from "../../util/scoreWidget";

type ScoreProps = {
    correct: number;
    incorrect: number;
    unanswered: number;
};
const Score = ({ correct, incorrect, unanswered }: ScoreProps) => {
    const total = correct + incorrect + unanswered;
    const chartConfig = useMemo(
        () =>
            buildChartConfig("doughnut", [
                { value: correct, color: "#5cb85c", label: "Correct" },
                { value: incorrect, color: "#d9534f", label: "Incorrect" },
                { value: unanswered, color: "#f0ad4e", label: "Unanswered" },
            ]),
        [correct, incorrect, unanswered],
    );
    return (
        <>
            <div className="score-widget-wrapper">
                <div className="score-widget-graph">
                    <Chart config={chartConfig} />
                </div>
                {/* absolute positioned to be in the center of the chart*/}
                <div className="score-widget-percentage">
                    {calcPercentage(correct, total)}%
                </div>
            </div>
            <div className="score-widget-breakdown">
                <h5>20 Question Test</h5>
                <ScoreBreakdownItem
                    label="CORRECT"
                    labelStyle="success"
                    count={correct}
                    total={total}
                />
                <ScoreBreakdownItem
                    label="INCORRECT"
                    labelStyle="danger"
                    count={incorrect}
                    total={total}
                />
                <ScoreBreakdownItem
                    label="UNANSWERED"
                    labelStyle="warning"
                    count={unanswered}
                    total={total}
                />
            </div>
        </>
    );
};
export default Score;
